<template>
    <!-- 对话框 -->
    <el-drawer title="添加优惠券信息" :visible.sync="show" :with-header="false" :before-close="closeDialog" size="60%"
               :wrapperClosable="true">

        <!-- 基本信息表单 -->
        <div class="form-box">

            <template>

                <el-form ref="form" label-width="80px" style="height: 90vh; overflow-y: auto;">

                    <el-form-item label="订单编号:" label-width='160px'>
                        <div class="lable-fontcolor">{{list_data.billno}}</div>
                    </el-form-item>
                    <el-form-item label="用户手机号码:" label-width='160px'>
                        <div class="lable-fontcolor">{{list_data.consumer_phone}}</div>
                    </el-form-item>
                    <el-form-item label="下单时间" label-width='160px'>
                        <div class="lable-fontcolor">{{list_data.order_time}}</div>
                    </el-form-item>

                    <el-form-item label="完成时间:" label-width='160px'>
                        <div class="lable-fontcolor">{{list_data.end_time_stamp}}</div>
                    </el-form-item>





                    <el-form-item label="畅行卡名称:" label-width='165px'>
                        <div class="lable-fontcolor">{{list_data.card_name}}</div>
                    </el-form-item>

                    <el-form-item label="畅行卡剩余次数:" label-width='160px'>
                        <div class="lable-fontcolor">{{list_data.last_num}}次</div>
                    </el-form-item>

                    <el-form-item label="已使用次数:" label-width='160px'>
                        <div class="lable-fontcolor">{{list_data.used_num}}次</div>
                    </el-form-item>

                    <el-form-item label="畅行卡限制次数:" label-width='160px'>
                        <div class="lable-fontcolor">{{list_data.limit_num==0?'无线':list_data.limit_num+'次'}}</div>
                    </el-form-item>

                    <el-form-item label="预估金额:" label-width='160px'>
                        <div class="lable-fontcolor">{{list_data.predict_amount}}</div>
                    </el-form-item>



                    <el-form-item label="实际金额:" label-width='160px'>
                        <div class="lable-fontcolor">{{list_data.amount}}</div>
                    </el-form-item>



                    <el-form-item label="实收金额:" label-width='160px'>
                        <div class="lable-fontcolor">{{list_data.finish_amount}}</div>
                    </el-form-item>

                    <el-form-item label="支付方式:" label-width='160px'>
                        <div class="lable-fontcolor">{{list_data.pay_channel}}</div>
                    </el-form-item>

                    <el-form-item label="付款通道:" label-width='160px'>
                        <div class="lable-fontcolor">{{list_data.pay_mode}}</div>
                    </el-form-item>






                </el-form>

                <!-- 对话框底部按钮 -->
                <div style="display: flex;justify-content: center;margin-top: 20px;">


                    <el-button @click="closeDialog">关闭</el-button>
                </div>

            </template>

        </div>

    </el-drawer>
</template>

<script>
    var _this;

    export default {

        props: {
            isShow: Boolean,
            data: ''
        },
        watch: {
            isShow(newData, oldData) {

                _this.show = true;
                _this.card_order_code = _this.data;


                //   请求详情接口
                _this.viewCard()


            },
        },
        data() {
            return {
                show: false,
                card_details_code: '',

                list_data:{}


            };
        },
        created() {
            _this = this;


        },
        methods: {

            //优惠券详情
            viewCard(){
                _this.$post(
                    "/card/cardUseDetails",{
                        card_order_code:_this.card_order_code,
                    },
                ).then(res => {

                    _this.list_data = res.data;


                }).catch((err) => {

                })


            },



            // 关闭方法
            closeDialog() {
                _this.show = false;
                _this.list_data = {}
            },



        },
    };
</script>

<style scoped>
    .lable-fontcolor{
        color: #606266;
    }
    .form-box {
        padding: 20px;
        box-sizing: border-box;
        margin-right: 0;
        width: 100%;
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409eff;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 100px;
        height: 100px;
        display: block;
    }

    .el-form-second {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
    }

    .avatar-uploader {
        width: 100px;
        height: 100px;
    }

    .avatar-uploader img {
        display: block;
        width: 100%;
        height: 100%;
    }

    .verify_remarks {
        font-size: 14px;
        color: #606266;
    }

    .quill-editor {
        width: 80%;
    }
</style>
